import { render, staticRenderFns } from "./project-results.html?vue&type=template&id=172074ae&"
import script from "./project-results.ts?vue&type=script&lang=ts&"
export * from "./project-results.ts?vue&type=script&lang=ts&"
import style0 from "./project-results.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports